import { useQueryClient } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';

import { configRepository } from '@/features/config/api/config.repository';
import { configKeys, useAppSettings } from '@/features/config/hooks/use-config';

/**
 * Warms the `app_settings` query cache and owns the single Realtime
 * subscription for it. Mounted at the app root (inside `QueryClientProvider`,
 * above `RootGate`) so `LoginRoute` — which is rendered before any session
 * exists — already has (or is actively fetching) config for gates like
 * `auth.email_login` / `auth.phone_otp`. While the fetch is in flight every
 * `useAppSettings().flag/num` call falls back to the REGISTRY default.
 */
export function ConfigProvider({ children }: { children: ReactNode }): JSX.Element {
  const queryClient = useQueryClient();
  useAppSettings();

  useEffect(() => {
    const unsubscribe = configRepository.subscribe(() => {
      void queryClient.invalidateQueries({ queryKey: configKeys.all });
    });
    return unsubscribe;
  }, [queryClient]);

  return <>{children}</>;
}
